import React from 'react';
import { Link } from 'react-router-dom';

const HireBanner: React.FC = () => (
  <section className="hire-banner-section">
    <div className="container">
      <div className="hire-banner">
        <div className="partner-glow" />
        <div className="hire-banner-text">
          <span className="section-label">Hire Developers</span>
          <h2>
            Need developers on your team?<br />
            <span className="gt">Hire them from us.</span>
          </h2>
          <p>
            We also provide Python, FastAPI, AWS, Docker, and system design
            developers who work directly with your team. Full-time, part-time,
            or by the hour.
          </p>
          <div className="tech-tags">
            {['Python', 'FastAPI', 'AWS', 'Docker', 'Kubernetes', 'System Design', 'LLMs & AI'].map(t => (
              <span className="tech-tag" key={t}>{t}</span>
            ))}
          </div>
        </div>
        <div className="hire-banner-actions">
          <Link to="/hire-developers" className="btn btn-primary partner-btn">
            Hire Developers
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default HireBanner;
